import React from "react";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

import type { NoticeTarget } from "src/types/notice/noticeTypes";

type Props = {
  noticeTtl: string;
  onChangeNoticeTtl: (v: string) => void;

  noticeTarget: NoticeTarget | "";
  activeYn: "" | "true" | "false";
  size: number;

  onChangeImmediate: (
    patch: Partial<{
      noticeTarget: NoticeTarget | undefined;
      activeYn: boolean | undefined;
      size: number;
    }>
  ) => void;

  onSearch: () => void;
  onReset: () => void;
  onCreate: () => void;
};

export default function NoticeFilterBar({
  noticeTtl,
  onChangeNoticeTtl,
  noticeTarget,
  activeYn,
  size,
  onChangeImmediate,
  onSearch,
  onReset,
  onCreate,
}: Props) {
  return (
    <Paper
      elevation={0}
      sx={{ border: "1px solid", borderColor: "divider", borderRadius: 2, p: 2 }}
    >
      <Stack
        direction="row"
        spacing={1.5}
        alignItems="center"
        justifyContent="space-between"
        flexWrap="wrap"
      >
        <Stack direction="row" spacing={1.5} alignItems="center" flexWrap="wrap">
          <TextField
            size="small"
            label="공지 제목 검색"
            value={noticeTtl}
            onChange={(e) => onChangeNoticeTtl(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") onSearch();
            }}
            sx={{ minWidth: 260 }}
          />

          <FormControl size="small" sx={{ minWidth: 170 }}>
            <InputLabel id="target-label">Target</InputLabel>
            <Select
              labelId="target-label"
              label="Target"
              value={noticeTarget}
              onChange={(e) =>
                onChangeImmediate({
                  noticeTarget: (e.target.value as any) || undefined,
                })
              }
            >
              <MenuItem value="">전체</MenuItem>
              <MenuItem value="STORE">STORE</MenuItem>
              <MenuItem value="SYSTEM">SYSTEM</MenuItem>
              <MenuItem value="CLINIC">CLINIC</MenuItem>
            </Select>
          </FormControl>

          <FormControl size="small" sx={{ minWidth: 150 }}>
            <InputLabel id="active-label">Active</InputLabel>
            <Select
              labelId="active-label"
              label="Active"
              value={activeYn}
              onChange={(e) =>
                onChangeImmediate({
                  activeYn: e.target.value === "" ? undefined : e.target.value === "true",
                })
              }
            >
              <MenuItem value="">전체</MenuItem>
              <MenuItem value="true">활성</MenuItem>
              <MenuItem value="false">비활성</MenuItem>
            </Select>
          </FormControl>

          <FormControl size="small" sx={{ minWidth: 120 }}>
            <InputLabel id="size-label">size</InputLabel>
            <Select
              labelId="size-label"
              label="size"
              value={size}
              onChange={(e) => onChangeImmediate({ size: Number(e.target.value) })}
            >
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
            </Select>
          </FormControl>
        </Stack>

        <Stack direction="row" spacing={1} alignItems="center">
          <Button variant="contained" onClick={onSearch}>
            검색
          </Button>
          <Button variant="outlined" onClick={onReset}>
            초기화
          </Button>
          <Button variant="contained" color="primary" onClick={onCreate}>
            + 공지 등록
          </Button>
        </Stack>
      </Stack>
    </Paper>
  );
}
